import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import { black, blue, lightGray, lightGrayThird } from '../../assets/ui/colors';

export const CardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: -8px;
`;


export const CardItem = styled.div`
    border: 1px solid ${lightGray};
    border-radius: 4px;
    margin: 8px;
    padding: 17px 22px 17px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: 0.3s;
    background: ${lightGray};
    color: ${black};
    font-size: 16px;
    line-height: 22px;
    border: ${props => props.isSelected ? blue : lightGray};
    color: ${props => props.isSelected ? 'white' : black};
    position: relative;
    :hover {
        background: ${lightGrayThird};
    }

    & .MuiPaper-rounded {
        background: ${lightGray};
        & .MuiListItem-button {
            :hover {
                background: ${lightGrayThird};
            }
        }
    }
`;

export const Price = styled.div`
    margin-left: auto;
    color: ${black};
    margin-right: 24px;
    @media (max-width: 600px) {
        margin-right: 12px;
    }
`;

export const CabinetsList = styled(Paper)`
    position: absolute;
    right: 0;
    left: 0;
    top: 58px;
    z-index: 10;
    padding: 2px 4px;
    display: flex;
    align-items: center;
    margin-top: 1px;
    max-height: 46vh;
    & .MuiList-padding {
        width: -webkit-fill-available;
        width: -moz-available;
        width: fill-available;
        max-height: inherit;
        overflow: auto;
    }
`;

export const NextBtn = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    height: 64px;
    width: 145px;
    z-index: 13000;
    cursor: pointer;
    @media (max-width: 600px) {
        width: 100px;
    }
`;
